var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxPayerDeclaration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.721 29.647s.696-3.171 1.965-2.254c1.542 1.114.489 4.761 2.511 4.414 1.13-.194 1.593-3.087 1.65-2.278.088 1.225 1.813 1.419 1.813 1.419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M30.989 24.087v8.422a5.243 5.243 0 01-5.243 5.243H11.684a5.243 5.243 0 01-5.243-5.243V13.065a5.246 5.246 0 013.666-5.002l1.327-.241h9.618"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20.839 15.504l11.88-11.879 5.537 5.537-11.879 11.879-7.918 2.38 2.38-7.917zM20.839 15.504l5.537 5.537"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.927,
    cy: 31.382,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxPayerDeclaration);
export default __webpack_public_path__ + "static/media/taxPayerDeclaration.fe05953ba97cda455b1ccb33fbc68658.svg";
export { ForwardRef as ReactComponent };